import { useTranslation } from "@src/hooks/useTranslation";
import NavigationMenu from "design-system/src/Navigation/NavigationMenu/NavigationMenu";
import React from "react";

const MyCartMenuFallback = () => {
  const { t } = useTranslation("Navigation");

  return (
    <NavigationMenu
      icon="cart"
      iconColor="white"
      label={`${t("Panier", "Navigation")} (0)`}
    ></NavigationMenu>
  );
};

export default MyCartMenuFallback;
